import { ODATA_EXPORT_SEPARATOR } from '@/tools/exportOData/odata.constants';

export const ODATA_EXPORTS_PER_PAGE = 15;
export const ODATA_EXPORT_NAME_SEPARATOR_REGEX = new RegExp(
  `^(.*?)(?=${ODATA_EXPORT_SEPARATOR})(.*)([a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12})(.*Capsule)?$`,
);
